import _ from "lodash";
import React from "react";
import { useI18n } from "Hooks";

// Utils
import { getAssessmentToolText } from "ClassRoom/modules/utils";

// Constants
import { TOOL_TYPE_TO_ELEMENT_TYPE_MAPPING } from "ClassRoom/modules/Constants";
import {
  SCORE,
  DP_ASSESSMENT_RUBRIC,
  ASSESSMENT_GRADE_BOUNDARY,
  SCORE_BASED_RUBRIC,
  STANDARD_BASED_RUBRIC,
  MYP_OBJECTIVE_RUBRIC,
  MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC,
} from "Constants/stringConstants";

// DS
import { Tooltip, IconButton } from "@toddle-edu/ds-web";
import { TickCircleOpenOutlined } from "@toddle-edu/ds-icons";

// Scss
import classes from "./AIGradingActions.scss";

const AIGradingActions = ({
  onAcceptAIEvaluation,
  academicTermId,
  assessmentToolType,
  toolResponses,
  ibPYPElementRatings,
}) => {
  const { t } = useI18n();

  const hasToolIbPypElementsRating = _.includes(
    [
      SCORE,
      DP_ASSESSMENT_RUBRIC,
      ASSESSMENT_GRADE_BOUNDARY,
      SCORE_BASED_RUBRIC,
      STANDARD_BASED_RUBRIC,
      MYP_OBJECTIVE_RUBRIC,
      MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC,
    ],
    assessmentToolType
  );

  const hasToolResponseAIRating = _.some(toolResponses, {
    creatorType: "AI",
    isDeleted: false,
  });

  const hasIbPypElementRatingAIRating = _.some(ibPYPElementRatings, {
    creatorType: "AI",
    isDeleted: false,
    ibPYPElementType: TOOL_TYPE_TO_ELEMENT_TYPE_MAPPING[assessmentToolType],
  });

  const isAIEvaluatedTool = hasToolIbPypElementsRating
    ? hasToolResponseAIRating || hasIbPypElementRatingAIRating
    : hasToolResponseAIRating;

  const { assessmentToolText: tickTooltipLabelParam } = getAssessmentToolText({
    t,
    assessmentToolType,
  });

  const tickTooltipLabel = t("ai:approve_ai_evaluation", {
    label: tickTooltipLabelParam,
  });

  return (
    <div className={classes.inlineEvaluationIconContainer}>
      {isAIEvaluatedTool ? (
        <Tooltip tooltip={tickTooltipLabel} dsVersion="2.0">
          <IconButton
            icon={<TickCircleOpenOutlined />}
            dsVersion="2.0"
            variant="neutral"
            type="plain"
            size="medium"
            disabled={!isAIEvaluatedTool}
            onClick={() =>
              onAcceptAIEvaluation({
                isAcceptAllForTool: true,
                academicTermId,
              })
            }
          />
        </Tooltip>
      ) : null}
    </div>
  );
};

export default AIGradingActions;
